import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, UncontrolledTooltip } from 'reactstrap';
import { FlowDocument } from '../../../../../services/types/Flow';
import { LinkButton, SpinnerArea } from '../../../../../shared/components';
import { customDateStr, tooltipPreventOverflowModifiers } from '../../../../../shared/misc/utils';
import Context from '../../../../App/MainProvider/context';
import flowDocumentService from '../../../../../services/flowDocumentService';

interface Props {
  data: FlowDocument[] | null;
  flowId: number;
  flowLap: number;
}

const DocumentsTable: React.FC<Props> = ({ flowId, flowLap, data }) => {
  const { t } = useTranslation();
  const { service } = useContext(Context);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const download = (docId: number) => {
    service(() => flowDocumentService.downloadDocument(flowId, flowLap, docId), {
      loader: setIsSubmitting,
    });
  };
  return (
    <SpinnerArea loading={isSubmitting}>
      <div className="history-content flow-history mb-0 table-responsive">
        <Table responsive>
          <thead>
            <tr>
              <th>{t('documentName')}</th>
              <th>{t('aideMemoire')}</th>
              <th>{t('modifiedBy')}</th>
              <th>{t('modifiedDate')}</th>
              <th style={{ width: '110px' }}>{t('actions')}</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((document) => (
                <tr key={`doc_table_document_${document.id}`}>
                  <td>{document.documentName}</td>
                  <td>
                    {document.aideMemoire ? (
                      <div className="badge-base flowstatus aide-memoire">
                        <div className="badge-text">
                          <span>{t('aideMemoire')}</span>
                        </div>
                      </div>
                    ) : null}
                  </td>
                  <td>{document.createdBy}</td>
                  <td>{customDateStr(document.createdOn)}</td>
                  <td className="upload-flow-documents-table__actions">
                    <div>
                      <LinkButton
                        key={`download_document_${document.id}`}
                        onClick={() => download(document.id)}
                        icon="file-download"
                      />
                      {document.createdVersion ? (
                        <>
                          <LinkButton htmlId={`createdVersion_${document.id}`} icon="info-circle" />
                          <UncontrolledTooltip
                            key={`tooltip_createdVersion_${document.id}`}
                            className="tooltip-documents"
                            placement="bottom"
                            target={`createdVersion_${document.id}`}
                            modifiers={tooltipPreventOverflowModifiers}
                          >
                            <p>
                              {t('documentTooltip', { createdVersion: document.createdVersion })}
                            </p>
                          </UncontrolledTooltip>
                        </>
                      ) : null}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </SpinnerArea>
  );
};

export default DocumentsTable;
